export const REMEMBERED_USERNAME_KEY = 'optimus.remembered-username';

export const PASSWORD_MASK_LENGTH = 8;
export const PASSWORD_MASK_CHARACTER = '•';

export const FORGOT_PASSWORD_MESSAGE = 'Please contact your administrator to reset your password.';
